import {
  AppBar,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useEffect, useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import KenGrid from '../../../../../global_components/KenGrid';
import KenDialogBox from '../../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import Kentable from '../../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import ChatLayout from '../../../components/ChatLayout';
import ChatInput from '../../../components/ChatInput';
import moment from 'moment';
import BreadCrumb from '../../../../../Components/BreadCrumb';
import { getGradingCourseDetails } from '../../../../../Utils/apiServices';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '150%',
    textTransform: 'uppercase',
    color: '#505F79',
    padding: 20,
  },
  body: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#505F79',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  // root: {
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  // },
}))(TableRow);

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'GRADING',
  },
];

const chatData = [
  {
    sender: true,
    message: `Hey, Could you please let me know which chapters I have to cover
  in UX/UI paper?`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
  {
    sender: false,
    message: `Hi Nandhini, you should include first 8 chapters in mid semester
    exam.`,
    profilePic: '',
    time: '3 days ago',
  },
  {
    sender: true,
    message: `Okay, Thank you gentleman!`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
];

const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };

  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
          cursor: 'pointer',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center ' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Jane Cooper'}
            </p>

            <p>A - 12345</p>
            <p>Campus 1</p>
            <p>Course 1</p>
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
    </>
  );
};
const ActionCellEdit = (row, isUpdating) => {
  const classes = useStyles();
  return (
    <Box>
      <div style={{ display: 'flex' }}>
        <Button
          variant="primary"
          component={Link}
          className={classes.editbtn}
          to={`${routes.grading}/details`}
        >
          View / Edit
        </Button>
        <Button
          variant="primary"
          component={Link}
          style={{
            color: '#505F79',
            background: 'rgba(196, 196, 196,0.2)',
            borderRadius: '20px',
            fontSize: '10px',
            margin: '5px 5px',
            height: '23px',

            '&:hover': {
              background: 'rgba(196, 196, 196,0.2)',
              color: '#505F79',
            },
          }}
          // to={`${routes.currentProgrammes}/${id}/details`}
        >
          Publish
        </Button>
      </div>
    </Box>
  );
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { status } = row.row.values;

  console.log({ status });

  let classOfBtn;
  if (status === 'Submitted for Grading') {
    classOfBtn = classes.normal;
  } else if (status === 'Under Approval') {
    classOfBtn = classes.medium;
  } else if (status === 'Not submitted') {
    classOfBtn = classes.error;
  } else {
    classOfBtn = classes.medium;
  }

  return (
    <Box>
      <Button
        variant="primary"
        component={Link}
        className={classOfBtn}
        style={{ alignContent: 'center' }}
        // to={`${routes.currentProgrammes}/${id}/details`}
      >
        {status}
      </Button>
    </Box>
  );
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const data = [
  {
    id: 1,
    course: <Link>ARTIFICAL INTILLEGENCE</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 2,
    course: <Link>UI/UX DESIGN</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Under Approval',
    action: 'action 1',
  },
  {
    id: 3,
    course: <Link>Cameron Williamson</Link>,
    subject: 'A - 03345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Not submitted',
    action: 'action 1',
  },
  {
    id: 4,
    course: <Link>Esther Howard</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 5,
    course: <Link>Wade Warren</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 6,
    course: <Link>Cameron Williamson</Link>,
    subject: 'A - 03345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 7,
    course: <Link>Jane Cooper</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 8,
    course: <Link>Wade Warren</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Course 1',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: '#c12002',
    height: '23px',

    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  normal: {
    color: '#02ab4a',
    background: 'rgba(138, 245, 196,0.4)',
    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  editbtn: {
    color: '#00218D',

    background: 'rgba(0, 33, 141,0.2)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(0, 33, 141,0.2)',

      color: '#00218D',
    },
    // color: '#FFFFFF',
    // background: '#00218D',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#00218D',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // width: '70%',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  table: {
    minWidth: 700,
    padding: 10,
  },
  tbCourseTerm: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  status: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#FFFFFF',
    borderRadius: '18px',
    padding: '8px 20px',
  },
  viewEditBtn: {
    // background: "#03248F",
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  publishBtn: {
    background: '#979797',
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  normal: {
    // color: '#505F79',
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',
    // background: '#27AE60',

    // background: '#02ab4a',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
      // border: '1px solid #02ab4a',
    },
  },
  medium: {
    color: '#f17100',
    background: 'rgba(255, 196, 10,0.2)',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: 'rgba(255, 196, 10,0.2)',
      color: '#f17100',
    },
  },
  error: {
    // color: '#F14B2D',

    background: 'rgba(241, 75, 45, 0.2)',
    // background: '#c12002',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid #c12002',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: '#c12002',
    height: '23px',
    width: '115px',

    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',

      // color: '#c12002',
      // borderBottom: '#F14B2D',
    },
  },
}));

const selectOptionsCampus = [
  {
    label: 'Select Campus',
    value: '--Select--',
  },
  {
    label: 'Campus 1',
    value: '1',
  },
  {
    label: 'Campus 2',
    value: '2',
  },
];

const selectOptionsProgram = [
  {
    label: 'Select Program',
    value: '--Select--',
  },
  {
    label: 'Program 1',
    value: '1',
  },
  {
    label: 'Program 2',
    value: '2',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsTerm = [
  {
    label: 'Select Term',
    value: '--Select--',
  },
  {
    label: 'Term 1',
    value: '1',
  },
  {
    label: 'Term 2',
    value: '2',
  },
];

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '--Select--',
  },
  {
    label: 'Batch 1',
    value: '1',
  },
  {
    label: 'Batch 2',
    value: '2',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const Grading = () => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectValueCampus, setSelectValueCampus] = useState(
    selectOptionsCampus[0].value
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };
  const [selectValueProgram, setSelectValueProgram] = useState(
    selectOptionsProgram[0].value
  );
  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState(
    selectOptionsTerm[0].value
  );
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
  };

  const [selectValueBatch, setSelectValueBatch] = useState(
    selectOptionsBatch[0].value
  );
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
      disableGlobalFilter: true,
    },
    {
      Header: 'COURSE',
      accessor: 'course',
      disableGlobalFilter: true,
    },
    {
      Header: 'SUBJECT',
      accessor: 'subject',
      disableGlobalFilter: true,
    },
    {
      Header: 'DATE OF EXAM',
      accessor: 'date_of_exam',
      disableGlobalFilter: true,
    },
    {
      Header: 'SUBJECT FACULTY',
      accessor: 'subject_faculty',
      disableGlobalFilter: true,
      // Cell: QuestionPaperCell,
    },
    {
      Header: 'STATUS',
      accessor: 'status',
      disableGlobalFilter: true,
      Cell: CellWithButton,
    },
    {
      Header: 'ACTIONS',
      accessor: 'action',
      Cell: ActionCellEdit,
    },
  ];

  // Editing
  const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);
  const [course, setCourse] = useState([]);

  useEffect(() => {
    getGradingCourseDetails()
      .then((res) => {
        console.log('getGradingCourseDetails', res);
        if (res !== null) {
          setCourse(res);
        }
      })
      .catch((err) => {
        console.log(' Grading Course Details error', err);
      });
  }, []);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Grading
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              // startIcon={<Message />}
              variant="contained"
              color="primary"
              component={Link}
              className={classes.addButton}
              // onClick={handleSendBulkMessageDialog}
              style={{ marginRight: '15px' }}
              to={routes.gradingSetting}
            >
              Grading Setting
            </Button>
            <Button
              variant="contained"
              color="primary"
              // style={{
              //   marginRight: '15px',
              //   background: '#979797',
              //   color: 'white',
              //   fontWeight: 'bold',
              //   textDecoration: 'none',
              //   textTransform: 'none',
              // }}
              className={classes.addButton}
              to={'#'}
            >
              Save
            </Button>
          </Grid>
        </Toolbar>
      </AppBar>
      {/* 
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={dataOfTable}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
            gridProps={{
              getCellProps: (row) => {
                if (
                  row.column.Header === 'Send Message' ||
                  row.column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (
                  column.Header === 'Send Message' ||
                  column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box> */}

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            EXAM FILTER
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => handleFilterDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={selectOptionsCampus}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Program"
              options={selectOptionsProgram}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject"
              options={selectOptionsSubject}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectOptionsTerm}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* new table design */}
      <TableContainer
        component={Paper}
        style={{ padding: '16px', marginTop: 16 }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>COURSE</StyledTableCell>
              <StyledTableCell>TERM</StyledTableCell>
              <StyledTableCell>DATE OF EXAM</StyledTableCell>
              <StyledTableCell>SUBJECT FACULTY</StyledTableCell>
              <StyledTableCell>STATUS</StyledTableCell>
              <StyledTableCell colSpan={2}>ACTIONS</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {course &&
              course?.map((ele, index) => {
                return (
                  <StyledTableRow key={ele?.courseName}>
                    <StyledTableCell className={classes.tbCourseTerm}>
                      {ele?.courseName}
                    </StyledTableCell>
                    <StyledTableCell className={classes.tbCourseTerm}>
                      {ele?.term}
                    </StyledTableCell>
                    <StyledTableCell>{ele?.deadline}</StyledTableCell>
                    <StyledTableCell>{ele?.subjectFaculty}</StyledTableCell>
                    <StyledTableCell>
                      <Button
                        className={
                          ele?.status && ele?.status === 'Under process'
                            ? classes.medium
                            : ele?.status === 'Approved'
                            ? classes.normal
                            : classes.error
                        }
                        /* style={{
                          backgroundColor:
                            ele?.status && ele?.status === 'Under process'
                              ? '#F2994A'
                              : ele?.status === 'Approved'
                              ? '#27AE60'
                              : '#EB5757',
                        }} */
                      >
                        {ele?.status}
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Button
                        className={classes.viewEditBtn}
                        color="primary"
                        size="small"
                        variant="contained"
                      >
                        <Link
                          style={{ color: '#fff' }}
                          to={{
                            pathname: `${routes.grading}/details`,
                            state: { gradingId: ele?.id },
                          }}
                        >
                          View / Edit
                        </Link>
                      </Button>
                    </StyledTableCell>
                    <StyledTableCell>
                      <Button
                        className={classes.publishBtn}
                        size="small"
                        variant="contained"
                      >
                        Publish
                      </Button>
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Grading;
